moment = require('moment')
_ = require('lodash')
{ partitionAndSort, get_from_list} = require('../../../utils')

module.exports = (
  $scope,
  $rootScope,
  $state,
  $q,
  $timeout,
  $stateParams,
  Assembler,
  Api,
  $uibModal,
  settings,
  workflowStepIterations,
  researchRequests,
  SpellingVariations,
  DataConcierge,
  arachnysDateFilter,
  adverseTermsLists,
  searchTermTypes,
  projectPermissions,
  User,
  ) ->

  spellingVariations = undefined

  # =========================
  # -------- Actions --------
  # =========================
  $scope.markStepComplete = (complete) ->
    if $scope.step.automatically_marked_complete and $scope.step.complete
      $scope.step.automatically_marked_complete = false
    $scope.step.complete = complete
    $scope.allSteps[$scope.step.id][0].complete = $scope.step.complete
    (new Api.WorkflowStep($scope.step).$updateAllowingValidationErrors()).catch (res) ->
      if res.status == 400 && 'complete' of res.data
        validationError = res.data['complete'][0]
        openServerSideConfirmModel(validationError).then () ->
          $scope.step.complete_confirm = true
          new Api.WorkflowStep($scope.step).$update()
      else
        $q.reject(res)
    .then () ->
      if complete
        return $timeout (() -> $scope.selectNext()), 50
    , () ->
      $scope.step.complete = !complete
      $scope.allSteps[$scope.step.id][0].complete = !complete

  $scope.openCompletionRequiredModal = () ->
    $uibModal.open
      template: require("./Partials/StepCompletionRequiredModal/step-completion-required-modal.html")
      controller: "StepCompletionRequiredModalController"

  $scope.openChoiceModal = () ->
    $scope.step.complete = false
    manualStepModal = $uibModal.open
      template: require("./Partials/ManualStepModal/manual-step-modal.html")
      controller: "ManualStepModalController"
      resolve:
        manualSteps: ->
          $scope.manualSources
    manualStepModal.result.then (result) ->
      if result == 'ignore'
        if !$scope.hasCompletedFlow($scope.step)
          $scope.displayFlowError()
        else
          $scope.markStepComplete(true)
      else if result == 'viewSources'
        $state.go('project.workflow.step.iteration.facets.manualchecks', { iterationId: $scope.getLastIterationId() } )

  $scope.displayFlowError = () ->
    $scope.step.complete = false
    $rootScope.error = 'You need to either add a summary or star a document to continue to the next step.'

  openServerSideConfirmModel = (validationError) ->
    serverSideCompletionModal = $uibModal.open
      template: require("./Partials/ServerSideConfirmCompletionModal/server-side-confirm-completion-modal.html")
      controller: "ServerSideConfirmCompletionModalController"
      resolve:
        validationError: () -> validationError
    return serverSideCompletionModal.result

  $scope.toggleStepNotApplicable = (notApplicable) ->
    $scope.step.not_applicable = notApplicable
    $scope.step.complete = false
    $scope.allSteps[$scope.step.id][0].not_applicable = $scope.step.not_applicable
    $scope.allSteps[$scope.step.id][0].complete = $scope.step.complete
    new Api.WorkflowStep($scope.step).$update()
    if notApplicable
      $timeout (-> $scope.selectNext()), 50

  $scope.toggleStepComplete = (complete) ->
    if $scope.workflow.manual_check_warnings && $scope.hasManualChecks() &&
    $state.current.name != 'project.workflow.step.iteration.facets.manualchecks'
      $scope.openChoiceModal()
    else if !$scope.hasCompletedFlow($scope.step)
      $scope.displayFlowError()
    else
      $scope.markStepComplete(complete)

  $scope.getCompleteStepToggleTooltip = (step) ->
    if step.not_applicable
      'This step cannot be completed as it is marked as not applicable'
    else if not projectPermissions.changeStep
      'You are not able to change the completed state of this step'
    else
      ''

  $scope.isCompleteStepToggleDisabled = (step) ->
    if step.not_applicable or not projectPermissions.changeStep
      true
    else
      false

  $scope.clickNext = () ->
    if $scope.isStepShouldBeCompleted($scope.step)
      $scope.openCompletionRequiredModal()
      return
    if $scope.hasManualChecks() and $state.current.name != 'project.workflow.step.iteration.facets.manualchecks'
      $state.go('project.workflow.step.iteration.facets.manualchecks', { iterationId: $scope.getLastIterationId() } )
    else
      $scope.selectNext()

  $scope.showDataConciergeOrderModal = (content) ->
    dcRequest = {country: $scope.getSearchCountry($scope.iteration).name, entity: $scope.iteration.query, type: $scope.step.name, content: content}
    DataConcierge.showOrderModal(dcRequest).then ( extra ) ->
      $scope.requestDataConciergeOrder(dcRequest, extra)

  $scope.requestDataConciergeOrder = (dcRequest, extra) ->
    composedContent = [
      "Type: " + dcRequest.type
      "Entity: " + dcRequest.entity
      "Country: " + dcRequest.country
      extra
    ].join( ". " )
    subject = dcRequest.type + ' (' + arachnysDateFilter(+new Date()) + ')'
    DataConcierge.addRequest(subject, $scope.step.id).then (request) ->
      DataConcierge.addMessage(request.id, composedContent).then () ->
        Api.ResearchRequest.query({workflow_step: $scope.step.id}).$promise.then (researchRequests) ->
          $scope.researchRequests = researchRequests

  $scope.encryptedMetadataGetter = () ->
    return Api.WorkflowEncryptedMetadata.get(
      {id: $scope.workflow.id}
    ).$promise.then((workflow) -> workflow.encrypted_metadata)

  # =========================
  # -------- Display --------
  # =========================

  $scope.checkStepSupportsSearchTermTypes = () ->
    return $scope.step.supports_search_term_types

  $scope.checkStepSupportsSubdivisions = () ->
    return $scope.step.supports_subdivisions and $scope.subdivisions.length

  $scope.checkStepSupportsAdditionalSearchTerm = () ->
    return $scope.step.additional_search_terms

  $scope.checkStepSupportsAdverseTerms = () ->
    return $scope.step.supports_adverse_terms

  $scope.checkAdverseTerms = () ->
    return $scope.iteration?.adverse_terms?.length > 0

  $scope.checkNoAdverseTerms = () ->
    return !$scope.checkAdverseTerms()

  $scope.checkDataConciergeAvailable = () ->
    return $scope.step.supports_data_concierge

  $scope.getCountry = (id) ->
    return "" unless id?
    return get_from_list($scope.countries, id)?.name or ""

  $scope.hideSearch = (state) ->
    state.current.name == 'project.workflow.step.support'

  $scope.getAdditionalCollection = (slug) ->
    mapping = {
      'city': $scope.cities,
      'county': $scope.counties
    }
    return mapping[slug]

  $scope.refreshSearchCollection = (value, slug) ->
    mapping = {
      'city': $scope.setCity,
      'county': $scope.setCounty
    }
    return mapping[slug](value)

  $scope.hasCompletedFlow = (step) ->
    if !$scope.workflow.force_flow
      return true
    ($scope.step.summary? and $scope.step.summary.length > 4) or $scope.starredCount(step) > 0

  $scope.isStepShouldBeCompleted = (step) ->
    if step.completion_required && !step.complete
      return true
    return false

  minimumSuggestedDispositioned = (step) ->
    if $scope.workers.hasRunning()
    then step.minimum_suggested_tagged_document_count
    else Math.min(step.minimum_suggested_tagged_document_count, $scope.workers.resultsAvailable())

  $scope.starredCount = (step) ->
    (s.id for k, s of $scope.starredDocs when s.workflow_step is step.id).length

  $scope.setActiveTab = ( tab ) ->
    $scope.activeTab = tab

  $scope.hasManualChecks = ->
    $scope.manualSources?.length > 0

  updateStepIterationsByName = ->
    if $scope.iteration
      $scope.stepIterations = spellingVariations.getIterationsForId( $scope.iteration.id )
      $scope.stepIterations = $scope.stepIterations?.slice().reverse()

  subjectNameFor = (iteration) ->
    if iteration.merged_name_variations and iteration.merged_name_variations.length then iteration.merged_name_variations[0].name else iteration.query

  allSubjectNamesFor = (iteration) ->
    if iteration.merged_name_variations then _.map(iteration.merged_name_variations, (variation) -> variation.name) else [iteration.query]

  latestIterationFor = (iteration) ->
    spellingVariations.getLatestIterationForId(iteration.id)

  setStepIterations = ( stepIterations ) ->
    spellingVariations = SpellingVariations.decorate({'iterations': stepIterations})
    spellingVariations.init()
    updateStepIterationsByName()
    $scope.hasDifferentBaseCountries = getHasDifferentBaseCountries(spellingVariations)
    $scope.tabs = getTabs(spellingVariations, $scope.hasDifferentBaseCountries)

  tabGroupKey = (tab) ->
    adverseTerms = '___ADVERSE_TERMS___' + (if tab.adverseTerms then tab.adverseTerms else '___NO_ADVERSE_TERMS___')
    names = '___SUBJECT_NAMES___' + tab.allSubjectNames.join('___SUBJECT_NAME_SEPARATOR___')
    return if $scope.hasDifferentBaseCountries then names + adverseTerms else tab.parentIterationId

  tabForParentIteration = (iteration) ->
    parent = spellingVariations.getIterationsForId(iteration.id)[0]
    latest = spellingVariations.getLatestIterationForId(iteration.id)
    return {
      latestIterationId: latest.id
      parentIterationId: parent.id
      subjectName: subjectNameFor(latest)
      allSubjectNames: allSubjectNamesFor(latest)
      latestIterationResults: latest.total_results
      totalResultsOverAllIterations: spellingVariations.getResultCountForId(parent.id)
      adverseTerms: if $scope.step.supports_adverse_terms then $scope.getAdverseTermsListName(latest) else ''
      countries: latest.base_countries
    }

  getHasDifferentBaseCountries = (spellingVariations) ->
    return _(spellingVariations.getParentIterations())
      .map (iteration) ->
        iteration.base_countries.join '__'
      .unique()
      .value()
      .length > 1

  getTabs = (spellingVariations, hasDifferentBaseCountries) ->
    ungroupedTabs = (tabForParentIteration(iteration) for iteration in spellingVariations.getParentIterations())

    return _(ungroupedTabs)
      .groupBy(tabGroupKey)
      .values()
      .map (group) ->
        startOfGroup = _.merge {}, group[0], type: 'iteration-country-group'
        restOfGroup = _.map group, (iteration) ->
          _.merge {}, iteration, type: 'iteration-country'
        multiCombinationGroup = [startOfGroup].concat(restOfGroup)

        singleCountryCombinationGroup = _.map group, (iteration) ->
          _.merge {}, iteration, type: 'iteration'

        return if hasDifferentBaseCountries then multiCombinationGroup else singleCountryCombinationGroup
      .flatten()
      .value()

  $scope.refreshStepIterations = ->
    Api.WorkflowStepIteration.query({workflow_step: $scope.step.id}).$promise.then ( stepIterations ) ->
      setStepIterations( stepIterations )

  $scope.getAdverseTermsListName = (iteration) ->
    # Returns a string with a human readable identifier for the adverse
    # terms list used.
    #
    # This includes the date of creation and a label if the list is
    # outdated or modified, for auditing purposes.
    #
    # Note this will return the name of the list that was used to create the
    # last iteration, even if the user has already selected a different list
    # in the UI. This should not be a problem because as soon as the user
    # accepts the new list, the UI will immediately 'refine the search' and
    # a new iteration will be created with the new list.
    #
    # Note equivalent logic is implemented for the exports in
    # workflow.exports._get_adverse_terms_list_name_for_iteration()

    if not iteration?.adverse_terms
      return "No Adverse Terms"

    adverse_terms_list = null
    adverse_terms_modified = false

    # The line endings on a new backdated list may differ from the original list, and that
    # would prevent the new list from being detected as "the list used to create this search".
    # So we need to normalize line endings before doing any comparisons. This might also apply
    # to a non-legacy search if it was created by clicking Go or Run Time Delta on a legacy
    # search with differing line endings
    adverse_terms_lf = iteration.adverse_terms.replace(/\r\n|\r/g, "\n")

    if iteration.adverse_terms_audited
      # Find the list object for the list ID stored in the iteration
      if iteration.adverse_terms_list
        for list in adverseTermsLists
          if list.id == iteration.adverse_terms_list
            adverse_terms_list = list
            if list.word_list.replace(/\r\n|\r/g, "\n") != adverse_terms_lf
              adverse_terms_modified = true
            break
    else
      # Legacy searches created before adverse terms auditing do not have adverse_terms_list
      # field populated. So we should try to work out if there was a list used.
      # We will pick the latest adverse terms list that contains the same words as the search
      # and was created before the search was created.
      # Note this might wrongly claim that a search was created with a list if the user
      # manually typed the same words as that list.
      # Note that, because we started auditing searches at the same time as lists, by the time
      # any "legacy search" was created, the list used could not have had a creation_date.
      # However, it is possible to backdate adverse terms list versions (which was proposed as
      # a way to improve auditing of old lists, by registering historic versions of adverse
      # terms lists).
      adverse_terms_created_date = ""
      for list in adverseTermsLists
        if list.word_list.replace(/\r\n|\r/g, "\n") == adverse_terms_lf and list.created_date < iteration.created_date
          if list.created_date > adverse_terms_created_date
            adverse_terms_list = list
            adverse_terms_created_date = list.created_date

      # Reasonably big hack: if the search didn't have a list and we found one, modify our
      # view of the search to look like the list ID had been there all along. This is so if
      # the user refines the search, the new iteration will have the list ID.
      if adverse_terms_list
        iteration.adverse_terms_list = adverse_terms_list.id

    if not adverse_terms_list
      return "Manual adverse terms"

    if not adverse_terms_list.is_latest_version and adverse_terms_modified
      label = ' [outdated & modified]'
    else if not adverse_terms_list.is_latest_version
      label = ' [outdated]'
    else if adverse_terms_modified
      label = ' [modified]'
    else
      label = ''

    return adverse_terms_list.name + ' (' + adverse_terms_list.created_date.split('T')[0] + ')' + label

  $scope.isActiveGroupTab = (tab) ->
    $scope.activeTab == 'search' && $scope.iteration && tabGroupKey(tab) == tabGroupKey(tabForParentIteration($scope.iteration))

  $scope.isActiveTab = (tab) ->
    $scope.activeTab == 'search' && $scope.iteration && spellingVariations.getIterationsForId($scope.iteration.id)[0]?.id == tab.parentIterationId

  $scope.getActiveTabIndex = () ->
    index = 0
    while index < $scope.tabs.length
      tab = $scope.tabs[index]
      if $scope.isActiveTab(tab)
        break
      index += 1
    return index

  $scope.getCountriesTabToolTip = (countriesIds) ->
    countries = ({name: c.name, iso_code: c.iso_code} for c in $scope.countries when c.id in countriesIds)

    if countries.length == 0
      return ''

    tooltip = "This tab searches sources specified for " + (c.name for c in countries when c.iso_code isnt 'glo').join(", ")
    if countries.some((c) -> c.iso_code == 'glo')
      return tooltip + " and specified international sources"
    return tooltip

  # Send clipper hints to the UDA when the page becomes visible (for example, when the user switches back to the tab)
  document.addEventListener 'visibilitychange', ->
    if not document.hidden
      sendClipperMessage()

  sendClipperMessage = () ->
    if (typeof $scope.chrome == 'undefined' || !$scope.chrome || typeof chrome.runtime == 'undefined')
      return
    $scope.findUDAIfInstalled (uda_id) ->
      if uda_id
        chrome.runtime.sendMessage(
          uda_id,
          {
            type: "clipper_hints",
            env_url: window.location.origin + "/workflow/",
            workflow: {
              id: $scope.workflow.id,
              name: $scope.workflow.name
            },
            report: {
              id: $scope.project.id,
              name: $scope.project.name
            },
            workflow_step: {
              id: $scope.step.id,
              name: $scope.step.name,
              workflow: $scope.workflow.id
            }
          },
          {},  # no options
          () -> undefined  # no callback
        )
      else
        false

  # =========================
  # ---------Select ---------
  # =========================

  $scope.setIteration = (iteration) ->
    spellingVariations.ensureHasIteration(iteration)
    $scope.iteration = iteration
    updateStepIterationsByName()
    $scope.hasDifferentBaseCountries = getHasDifferentBaseCountries(spellingVariations)
    $scope.tabs = getTabs(spellingVariations, $scope.hasDifferentBaseCountries)

  $scope.setLoaded = (state) ->
    $scope.loaded = state

  # =========================
  # --------- Scope ---------
  # =========================

  $scope.user = User

  $scope.projectPermissions = projectPermissions
  $scope.setCurrentStep($stateParams.workflowStepId)
  $scope.loaded = false

  $scope.subdivisions = []
  $scope.cities = []
  $scope.counties = []

  setStepIterations( workflowStepIterations )

  $scope.setResearchRequests( researchRequests )

  sendClipperMessage()

  $scope.setWorkers = (workers) ->
    $scope.workers = workers

  $scope.setSubdivisions = () ->
    if $scope.step.supports_subdivisions
      if $scope.step.static_subdivision_iso_code
        Api.Country.query().$promise.then (list_of_countries) ->
          for country in list_of_countries
            if country.iso_code == $scope.step.static_subdivision_iso_code
              $scope.country = country.iso_code
              $scope.subdivisions = if country then country.subdivisions else []
      else
        Api.Country.get({"id": $scope.workflow.countries}).$promise.then (country) ->
          $scope.country = country.iso_code
          $scope.subdivisions = if country then country.subdivisions else []
    else
      $scope.subdivisions = null

  $scope.setAdditionalTermModel = (term) ->
    if term.validation_model
      if term.validation_model == "city"
        $scope.setCity()
      if term.validation_model == "country"
        $scope.setCounty()
    if ($scope.iteration.include_additional_filters && term.slug of $scope.iteration.include_additional_filters)
      $scope.iteration[term.slug] = {'name': $scope.iteration.include_additional_filters[term.slug][0]}

  $scope.refreshAdditionalFilterDependantCollection = (slug = null) ->
    if !slug?
      $scope.setCity()
      $scope.setCounty()
    else if slug == "county"
      $scope.setCity()

  $scope.setCounty = (value = null) ->
    if $scope.step.additional_search_terms
      defaultCountry = "US"
      query = {"country_iso_code": $scope.country || defaultCountry, "name": value, "type": "county"}
      query = $scope.setSubdivisionQuery(query, 'parent_id')
      Api.Subdivision.query(query).$promise.then (response) ->
        $scope.counties = response.results

  $scope.setCity = (value = null) ->
    if $scope.step.additional_search_terms
      defaultCountry = "US"
      query = {"country_iso_code": $scope.country || defaultCountry, "name": value}
      query = $scope.setSubdivisionQuery(query, 'subdivision_id')
      if $scope.iteration.county
        query['subdivision_iso_code'] = $scope.iteration.county.iso_code
      Api.City.query(query).$promise.then (response) ->
        $scope.cities = response.results

  $scope.setSubdivisionQuery = (query, param_name) ->
    if $scope.iteration.subdivisions
      if Array.isArray($scope.iteration.subdivisions) and $scope.iteration.subdivisions.length > 0
        query[param_name] = $scope.iteration.subdivisions[0]
      else
        query[param_name] = $scope.iteration.subdivisions
    return query

  $scope.setAdditionalFilterValue = (slug) ->
    if ($scope.iteration.include_additional_filters && slug of $scope.iteration.include_additional_filters)
      $scope.iteration[slug] = $scope.iteration.include_additional_filters[slug][0]

  $scope.setFilteredWorkers = (filteredWorkers) ->
    $scope.filteredWorkers = filteredWorkers

  $scope.setManualChecks = ( manualChecks ) ->
    $scope.manualSources = manualChecks
    Assembler.linkArrayItems( $scope.manualSources, 'request', $scope.researchRequests, 'manual_step' )

  $scope.activeTab = undefined
  $scope.refine_query = { query: $scope.workflow.translated_query ? $scope.workflow.query }

  $scope.state = $state
  $scope.adverseTermsLists = adverseTermsLists
  $scope.searchTermTypes = searchTermTypes

  # =========================
  # ----- Soft routing ------
  # =========================

  $scope.getLastIterationId = ->
    workflowStepIterations[ workflowStepIterations.length - 1 ].id

  $scope.isCustomStep = () ->
    $scope.step.custom_step_url? and $scope.step.custom_step_url != ''

  redirectToIteration = () ->
    params =
      projectId: $scope.project.id
      workflowId: $scope.workflow.id
      workflowStepId: $scope.step.id
      iterationId: $scope.getLastIterationId()
    $state.go( '.iteration', params )

  if $state.current.name == 'project.workflow.step'
    if $scope.isCustomStep()
      $state.go('.custom')
    else
      redirectToIteration()
